var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "row mb-ngrid" },
      _vm._l(_vm.items, function (item, key) {
        return _c(`${_vm.type}-card`, {
          key: key,
          tag: "component",
          class: [_vm.colClass, "mb-grid"],
          attrs: {
            data: item,
            url: _vm.cardUrl,
            "url-params": _vm.cardUrlParams,
            "data-aos": "fade-up",
            "data-aos-delay": key * 50,
          },
        })
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "infinite-loading",
            {
              ref: "infiniteLoading",
              attrs: { spinner: "waveDots" },
              on: { infinite: _vm.loadData },
            },
            [
              _c("span", { attrs: { slot: "no-more" }, slot: "no-more" }),
              _vm._v(" "),
              _c("span", { attrs: { slot: "no-results" }, slot: "no-results" }),
              _vm._v(" "),
              _c(
                "span",
                { attrs: { slot: "spinner" }, slot: "spinner" },
                [_c("loader")],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }